import { Box, LinearProgress, Stack, Typography } from "@mui/material"
import useAuth from "../../../hooks/useAuth"

const AssetTypeDistribution = ({ allocations, selectedClass, setSelectedClass }) => {
	const { auth } = useAuth()

	// Se os usuario nao for administrador, mostra apenas STOCKS e ACOES
	const filteredAllocations = auth.userId > 100 ? allocations.filter(item => item.assetType === 'STOCK' || item.assetType === 'ACAO') : allocations

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
			<Typography variant="h6" gutterBottom>Distribuição por classe de ativo</Typography>
			<Box sx={{ flex: 1, overflowY: 'auto', pr: 0.5 }}>
				<Stack spacing={2}>
					<Stack spacing={1}>
						{filteredAllocations.map((item) => (
							<Box
								key={item.label}
								display="flex"
								alignItems="center"
								gap={1}
								onClick={() => setSelectedClass(item.assetType)}
								sx={{
									cursor: 'pointer',
									padding: '6px 8px',
									borderRadius: 1,
									border: selectedClass === item.assetType ? '1px solid rgba(25,118,210,0.4)' : '1px solid transparent',
									backgroundColor: selectedClass === item.assetType ? 'rgba(25,118,210,0.08)' : 'transparent'
								}}
								>
								<Typography variant="body2" sx={{ width: 90, flexShrink: 0 }}>{item.label}</Typography>
								<Box sx={{ flex: 1 }}>
									<LinearProgress
										variant="determinate"
										value={item.current}
										sx={{ height: 8, borderRadius: 6, backgroundColor: '#eeeeee' }}
									/>
									<LinearProgress
										variant="determinate"
										value={item.planned}
										color="secondary"
										sx={{ height: 8, borderRadius: 6, backgroundColor: 'transparent', marginTop: 0.5 }}
									/>
								</Box>
								<Box display="flex" flexDirection="column" alignItems="flex-end" minWidth={64}>
									<Typography variant="body2">{item.current}%</Typography>
									<Typography variant="caption" color="text.secondary">plan {item.planned}%</Typography>
								</Box>
							</Box>
						))}
					</Stack>
				</Stack>
			</Box>
		</Box>
	)
}

export default AssetTypeDistribution
